module.exports = __webpack_public_path__ + "img/app_store.18b9de12.png";